export default {
    buscando: false,
    items: [],
    // selecionado: {},
    perfil: {},
    menus: [],
    menusPorPerfis: []
}